import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import {
    getUnitListPrice,
    getUnitNetPrice,
    getUnitRegularPriceWithVat,
} from "@insite/client-framework/Services/Helpers/ProductPriceService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    CartLineModel,
    ProductPriceDto,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import ProductPriceSavingsMessage from "@insite/content-library/Components/ProductPriceSavingsMessage";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomInfoIcon from "@tCentro/Icons/CustomInfoIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import NISInfoIcon from "@tCentro/Icons/NISInfoIcon";

interface OwnProps {
    product: ProductContextModel | CartLineModel;
    currencySymbol?: string;
    showLabel?: boolean;
    showUnitOfMeasure?: boolean;
    showPack?: boolean;
    showSavings?: boolean;
    showSavingsAmount?: boolean;
    showSavingsPercent?: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: NISProductPriceStylesPDP;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    currencySymbol: ownProps.currencySymbol ?? state.context.session.currency?.currencySymbol ?? "",
    canSeePrices: getSettingsCollection(state).productSettings.canSeePrices,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
    session: state.context.session,
    showPricing: state.context.showPricing,
    isCheckoutReviewAndSubmitPage: getCurrentPage(state).type === "CheckoutReviewAndSubmitPage",
    productSettings: getSettingsCollection(state).productSettings,
    isCartPage: getCurrentPage(state).type === "CartPage",
    cart: getCurrentCartState(state).value,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface NISProductPriceStylesPDP {
    wrapper?: any;
    priceLabelText?: TypographyPresentationProps;
    quoteMessageWrapper?: InjectableCss;
    quoteMessage?: RequiresQuoteMessageStyle;
    unitOfMeasure?: UnitOfMeasureStyles;
    priceWrapper?: InjectableCss;
    price?: PriceStyles;
    priceForPlp?:PriceStyles;
    invalidPriceText?: TypographyPresentationProps;
    secondaryPriceWrapper?: InjectableCss;
    secondaryPrice?: PriceStyles;
    packWrapper?: InjectableCss;
    packLabelText?: TypographyPresentationProps;
    packDescriptionText?: TypographyPresentationProps;
    savingsMessageText?: TypographyPresentationProps;
    parent?: InjectableCss;
    parentLabel?: InjectableCss;
    unitListPrice?: TypographyProps;
    unitListPriceText?: InjectableCss;
    salePriceLabeltext?: InjectableCss;
    loginContainer?: InjectableCss;
    linkStylesLogin?: InjectableCss;
    loginMessageStyles?: InjectableCss;
    regularPrice?: InjectableCss;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    requireDrawingApproval?: InjectableCss;
    requireDrawingApprovalWrapper?: InjectableCss;
    drawwingApprovalIcon?: IconPresentationProps;
    envelopeIconStyles?: IconPresentationProps;
    requireDrawingApprovalCartWrapper?: InjectableCss;
    infoIconStyle?: IconPresentationProps;
    tooltipContainerStyles?: InjectableCss;
}

interface RequiresQuoteMessageStyle {
    text?: TypographyPresentationProps;
    tooltip?: TooltipPresentationProps;
}

interface PriceStyles {
    priceText?: TypographyPresentationProps;
    signInText?: TypographyPresentationProps;
    errorText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    unitOfMeasure?: UnitOfMeasureStyles;
    /**
     * @deprecated Use the `unitOfMeasure.unitOfMeasureText` property instead.
     */
    unitOfMeasureText?: TypographyPresentationProps;
    qtyPerBaseUnitOfMeasureText?: TypographyPresentationProps;
    vatLabelText?: TypographyPresentationProps;
    parentLabel?: InjectableCss;
    unitListPrice?: TypographyProps;
    unitListPriceText?: InjectableCss;
    salePriceLabeltext?: InjectableCss;
    unitListSpan?: InjectableCss;
}

interface UnitOfMeasureStyles {
    unitOfMeasureText?: TypographyPresentationProps;
}

export const nisProductPriceStylesPDP: NISProductPriceStylesPDP = {
    tooltipContainerStyles: {
        css: css`
            background-color: #262525;
            border-radius: 4px;
            width: max-content;
            box-shadow: 0px 4px 8px 0px rgba(38, 37, 37, 0.24);
            background-color: #262525;
            border-radius: 4px;
            box-shadow: 0px 4px 8px 0px rgba(38, 37, 37, 0.24);
            position: absolute;
            z-index: 999;
            font-size: 12px;
            font-style: normal;
            line-height: 16px;
            padding: 10px;
            color: white;
            width: 200px;
            font-family: Roboto;
            bottom: 40px;
            left: -88px;
            font-weight: 500;
            &:after {
                content: "";
                border-left: 0px solid #262525;
                border-right: 4px solid #262525;
                position: absolute;
                z-index: 999;
                bottom: -20px;
                left: 44%;
                width: 0px;
                height: 16px;
                width: 0px;
                height: 0px;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 20px solid #262525;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        left: -8px;
                        &:after {
                            bottom: -19px;
                        }
                    `,
                    css`
                        left: -8px;
                        &:after {
                            bottom: -19px;
                        }
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    infoIconStyle: {
        css: css`
            svg {
                width: 20px;
                height: 20px;
            }
            width: 20px !important;
            height: 20px !important;
        `,
    },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    loginContainer: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    linkStylesLogin: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
        `,
    },
    loginMessageStyles: {
        css: css`
            color: ${getColor("text.main")};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            margin-left: 4px;
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    requireDrawingApprovalCartWrapper: {
        css: css`
            flex: 1 1 auto;
            max-width: 290px !important;
            width: 100% !important;
            display: flex;
            flex-direction: row;
            color: #3ca865;
            padding-top: 8px;
        `,
    },
    requireDrawingApprovalWrapper: {
        css: css`
            flex: 1 1 auto;
            max-width: 100%;
            width: 100% !important;
            display: flex;
            flex-direction: row;
            color: #3ca865;
            padding-top: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 8px 0px 0px 5px;
                    `,
                    css`
                        padding: 8px 0px 0px 5px;
                    `,
                    css`
                        padding: 8px 0px 0px 5px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    drawwingApprovalIcon: {
        size: 12,
        css: css`
            > svg {
                > path {
                    fill: #3ca865;
                }
            }
        `,
    },
    requireDrawingApproval: {
        css: css`
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #3ca865;
            margin-left: 5px;
        `,
    },
    regularPrice: {
        css: css`
            display: flex;
            gap: 4px;
            .unitPrice {
                text-decoration: line-through;
                font-weight: 600;
                font-size: 24px;
                line-height: 32px;
                color: #838b90 !important;
                font-family: Roboto Condensed;
                //  padding-left:4px;
            }

            .savingsPer {
                color: #36603a;
                font-weight: 600;
                font-size: 24px !important;
                line-height: 32px !important;
                font-family: Roboto Condensed;
            }
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin: 16px 0px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 16px 0px 24px 0px;
                    `,
                    css`
                        margin: 16px 0px 24px 0px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    priceLabelText: {
        variant: "legend",
    },
    priceWrapper: {
        css: css`
            ${wrapInContainerStyles}
            div {
                span[data-test-selector^="productPrice_unitOfMeasureLabel"] {
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
    price: {
        errorText: { weight: "bold" },
        parentLabel: {
            css: css`
                display: flex;
                justify-content: left;
                align-items: center;
                & > span {
                    font-size: 24px;
                    line-height: 32px;
                    margin-right: 5px;
                }

                h4 {
                    font-size: 20px;
                }
            `,
        },

        salePriceLabeltext: {
            css: css`
                font-size: 24px;
                font-weight: 600;
                color: #262525;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 18px !important;
                        `,
                        css`
                            font-size: 18px !important;
                        `,
                        null,
                        null,
                    ])}
                @media (min-width: 992px) and (max-width: 1024px) {
                    font-size: 24px !important;
                }
            `,
        },
        unitListPriceText: {
            css: css`
                margin: 0 !important;
                font-size: 32px !important;
                font-weight: 600;
                line-height: 40px !important;
                color: #000000 !important;
                font-family: Roboto Condensed;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 32px !important;
                        `,
                        css`
                            font-size: 32px !important;
                        `,
                        null,
                        null,
                    ])}
                @media (min-width: 992px) and (max-width: 1024px) {
                    font-size: 24px !important;
                }
            `,
        },
        unitListPrice: {
            css: css`
                color: ${getColor("text.main")};
                text-decoration: line-through;
                font-size: 12px;
                font-weight: 400;
                margin-left: 8px;
                vertical-align: bottom;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 14px !important;
                        `,
                        null,

                        css`
                            font-size: 14px !important;
                        `,
                        null,
                    ])}
            `,
        },
        unitListSpan: {
            css: css`
                padding-left: 8px;
                font-size: 18px;
                font-weight: 400;
                line-height: 24px;
                color: ${getColor("text.main")};
            `,
        },

        realTimeText: {
            weight: "bold",
            css: css`
                display: inline-block;
                text-align: left;
                min-width: 25px;

                &::after {
                    overflow: hidden;
                    display: inline-block;
                    vertical-align: bottom;
                    animation: ellipsis steps(4, end) 900ms infinite 1s;
                    content: "\\2026";
                    width: 0;
                }

                @keyframes ellipsis {
                    to {
                        width: 1.25em;
                    }
                }
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                css: css`
                    color: ${COLORS.text.mineShaft};
                    font-weight: 400 !important;
                    margin-top: 13px;
                    white-space: nowrap;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 18px !important;
                            `,
                            css`
                                font-size: 18px !important;
                            `,
                            null,
                            null,
                        ])}
                    @media (min-width: 992px) and (max-width: 1024px) {
                        font-size: ${TYPOGRAPHY.size.large};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                    }
                `,
            },
        },
        vatLabelText: {
            css: css`
                font-size: 12px;
            `,
        },
    },
    invalidPriceText: {
        color: "danger",
    },
    secondaryPriceWrapper: {
        css: css`
            margin-top: 5px;
            ${wrapInContainerStyles}
        `,
    },
    secondaryPrice: {
        priceText: { weight: "bold" },
        errorText: { weight: "bold" },
        realTimeText: {
            weight: "bold",
            css: css`
                display: inline-block;
                text-align: left;
                min-width: 25px;

                &::after {
                    overflow: hidden;
                    display: inline-block;
                    vertical-align: bottom;
                    animation: ellipsis steps(4, end) 900ms infinite 1s;
                    content: "\\2026";
                    width: 0;
                }

                @keyframes ellipsis {
                    to {
                        width: 1.25em;
                    }
                }
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                css: css`
                    white-space: nowrap;
                    font-size: 12px !important;
                `,
            },
        },
        vatLabelText: {
            css: css`
                font-size: 12px;
            `,
        },
    },
    packWrapper: {
        css: css`
            margin-bottom: 8px;
        `,
    },
    packLabelText: {
        weight: "bold",
    },
    savingsMessageText: {
        italic: true,
        size: "12px",
        css: css`
            margin-bottom: 5px;
        `,
    },
    quoteMessage: {
        text: {
            css: css`
                font-family: "Roboto Condensed" !important;
                font-weight: 600 !important;
                font-size: 24px !important;
                line-height: 32px !important;
                color: #333333 !important;
            `,
        },
    },
    quoteMessageWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: 4px;
        `,
    },
};

const SectionWrapper = getStyledWrapper("section");

const NISProductPriceCustomPDP = ({
    product: pricingData,
    currencySymbol,
    canSeePrices,
    showLabel = true,
    showUnitOfMeasure = true,
    showPack = true,
    showSavings = false,
    showSavingsAmount = false,
    showSavingsPercent = false,
    showInvalidPriceMessage = false,
    enableVat,
    vatPriceDisplay,
    extendedStyles,
    session,
    showPricing,
    isCheckoutReviewAndSubmitPage,
    productSettings,
    cart,
    isCartPage,
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(nisProductPriceStylesPDP, extendedStyles));
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    if (!showPricing && !isCheckoutReviewAndSubmitPage) {
        return null;
    }

    const productContextModel = pricingData as ProductContextModel;
    const cartLineModel = pricingData as CartLineModel;

    const inventory = productContextModel.productInfo.inventory;

    const [isRequiredDrawingApproval, setIsRequiredDrawingApproval] = useState(false);
    const tooltipRef = React.useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                setShowTooltip(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        if (productContextModel.product?.properties?.requiredDrawingApproval === "true") {
            setIsRequiredDrawingApproval(true);
        }
    }, []);

    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId: productContextModel.product.id,
            unitOfMeasure: productContextModel.productInfo.unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const unitOfMeasureDescription =
        "product" in pricingData
            ? pricingData.product.unitOfMeasures?.find(o => o.unitOfMeasure === pricingData.productInfo.unitOfMeasure)
                  ?.description
            : pricingData.unitOfMeasureDescription;
    const unitOfMeasureDisplay =
        "product" in pricingData
            ? pricingData.product.unitOfMeasures?.find(o => o.unitOfMeasure === pricingData.productInfo.unitOfMeasure)
                  ?.unitOfMeasureDisplay
            : pricingData.unitOfMeasureDisplay;
    const quoteRequired = productContextModel.product
        ? productContextModel.product.quoteRequired
        : cartLineModel.quoteRequired;
    const qtyOrdered = productContextModel.product
        ? productContextModel.productInfo.qtyOrdered
        : cartLineModel.qtyOrdered;

    const pricing = "product" in pricingData ? pricingData.productInfo.pricing : pricingData.pricing;
    const allowZeroPricing =
        "product" in pricingData ? pricingData.product.allowZeroPricing : pricingData.allowZeroPricing;
    const isPromotionItem = "product" in pricingData ? false : pricingData.isPromotionItem;
    const isInvalidPrice =
        !quoteRequired &&
        !isPromotionItem &&
        !allowZeroPricing &&
        pricing?.unitNetPrice === 0 &&
        pricing?.unitRegularPrice === 0;

    const unitOfMeasure = unitOfMeasureDescription || unitOfMeasureDisplay;
    const showQtyPerBaseUnitOfMeasure =
        "baseUnitOfMeasure" in pricingData &&
        pricingData.unitOfMeasure !== pricingData.baseUnitOfMeasure &&
        pricingData.qtyPerBaseUnitOfMeasure > 0;
    const packDescription = "product" in pricingData ? pricingData.product.packDescription : undefined;

    const quoteStyles = styles.quoteMessage || {};
    const priceStyles = styles.price || {};
    const secondaryPriceStyles = styles.secondaryPrice || {};
    const unitListPrice = pricing?.unitListPrice ?? 0;
    const unitNetPrice = pricing?.unitNetPrice ?? 0;

    const savingsAmount = Math.round((unitListPrice - unitNetPrice) * 100) / 100;
    const savingsPercent = Math.round((savingsAmount / unitListPrice) * 100);
    const [showToolTip, setShowTooltip] = useState(false);

    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;
    if (!canSeePrices) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography {...priceStyles.signInText} data-test-selector="productPrice_PricingMessage">
                    {siteMessage("Pricing_SignInForPrice")}
                </Typography>
            </StyledWrapper>
        );
    }

    if ("product" in pricingData && pricingData.productInfo.failedToLoadPricing) {
        return (
            <SectionWrapper {...styles.wrapper}>
                <Typography {...priceStyles.errorText} data-test-selector="productPrice_PricingMessage">
                    {siteMessage("RealTimePricing_PriceLoadFailed")}
                </Typography>
            </SectionWrapper>
        );
    }

    if (quoteRequired) {
        return (
            <SectionWrapper {...styles.wrapper}>
                {showLabel && <Typography {...styles.priceLabelText}>{translate("Price")}</Typography>}
                <StyledWrapper {...styles.quoteMessageWrapper}>
                    <StyledWrapper
                        ref={tooltipRef}
                        style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
                    >
                        <Icon
                            onClick={() => setShowTooltip(prev => !prev)}
                            src={NISInfoIcon}
                            {...styles.infoIconStyle}
                            style={{ cursor: "pointer" }}
                        />
                        {showToolTip && (
                            <StyledWrapper {...styles.tooltipContainerStyles}>
                                <Typography as="span">{siteMessage("Rfq_TooltipMessage").toString()}</Typography>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>

                    <Typography {...quoteStyles.text} data-test-selector="quoteRequiredText">
                        {translate("Requires Quote")}
                    </Typography>

                    <UnitOfMeasure
                        unitOfMeasure={unitOfMeasure}
                        showUnitOfMeasure={showUnitOfMeasure}
                        styles={styles.unitOfMeasure}
                    />
                </StyledWrapper>
            </SectionWrapper>
        );
    }

    const displayVatForPrice = vatPriceDisplay === "DisplayWithVat" || vatPriceDisplay === "DisplayWithAndWithoutVat";
    const showSecondaryPrice = enableVat && vatPriceDisplay === "DisplayWithAndWithoutVat";

    const showLink = (
        availability: AvailabilityDto | undefined,
        trackInventory: boolean,
        productSettings: ProductSettingsModel,
        isProductDetailsPage?: boolean,
    ): boolean => {
        if (
            !availability ||
            availability.messageType === AvailabilityMessageType.NoMessage ||
            !trackInventory ||
            !productSettings.showInventoryAvailability ||
            !productSettings.displayInventoryPerWarehouse
        ) {
            return false;
        }

        if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
            return true;
        }

        return !!isProductDetailsPage;
    };

    return (
        <SectionWrapper {...styles.wrapper}>
            {pricing && showSavings && savingsPercent > 2 && (
                <Typography {...styles.regularPrice}>
                    {" "}
                    <span className="savingsPer">
                        {" "}
                        {translate("Save ")} {savingsPercent}%{" "}
                    </span>
                    <span className="unitPrice">{pricing.unitListPriceDisplay}</span>{" "}
                </Typography>
            )}
            {showLabel && <Typography {...styles.priceLabelText}>{translate("Price")}</Typography>}
            <StyledWrapper {...styles.priceWrapper} data-test-selector="priceIncludeVat">
                <Price
                    currencySymbol={currencySymbol}
                    pricing={pricing}
                    qtyOrdered={qtyOrdered}
                    unitOfMeasure={unitOfMeasure}
                    showUnitOfMeasure={showUnitOfMeasure}
                    enableVat={enableVat}
                    displayWithVat={displayVatForPrice}
                    styles={priceStyles}
                    salePriceLabel={
                        productContextModel.product?.salePriceLabel ||
                        cartLineModel?.salePriceLabel ||
                        translate("Sale Price:")
                    }
                />

                {isInvalidPrice && showInvalidPriceMessage && (
                    <Typography as="p" {...styles.invalidPriceText}>
                        {translate("Invalid Price")}
                    </Typography>
                )}
            </StyledWrapper>
            {showSecondaryPrice && (
                <StyledWrapper {...styles.secondaryPriceWrapper} data-test-selector="priceExcludeVat">
                    <Price
                        currencySymbol={currencySymbol}
                        pricing={pricing}
                        qtyOrdered={qtyOrdered}
                        unitOfMeasure={unitOfMeasure}
                        showUnitOfMeasure={showUnitOfMeasure}
                        enableVat={enableVat}
                        displayWithVat={false}
                        styles={secondaryPriceStyles}
                    />
                </StyledWrapper>
            )}
            {showQtyPerBaseUnitOfMeasure && "baseUnitOfMeasure" in pricingData && (
                <Typography {...priceStyles.qtyPerBaseUnitOfMeasureText}>
                    {`${pricingData.qtyPerBaseUnitOfMeasure} ${pricingData.baseUnitOfMeasureDisplay} / ${unitOfMeasure}`}
                </Typography>
            )}
            {packDescription && showPack && (
                <StyledWrapper {...styles.packWrapper}>
                    <Typography {...styles.packLabelText}>{translate("Pack")}:&nbsp;</Typography>
                    <Typography {...styles.packDescriptionText}>{packDescription}</Typography>
                </StyledWrapper>
            )}

            {showLink(availability, productContextModel.product.trackInventory, productSettings, true) && (
                <GridItem {...styles.availabilityByWarehouseLinkGridItem}>
                    <Link
                        {...styles.availabilityByWarehouseLink}
                        onClick={viewAvailabilityByWarehouseClickHandler}
                        data-test-selector="availabilityByWarehouseLink"
                    >
                        {translate("View Availability by Warehouse")}
                    </Link>
                    <Modal
                        {...styles.availabilityByWarehouseModal}
                        headline={translate("Warehouse Inventory")}
                        isOpen={modalIsOpen}
                        handleClose={modalCloseHandler}
                    >
                        {isLoading && (
                            <StyledWrapper {...styles.centeringWrapper}>
                                <LoadingSpinner {...styles.spinner} />
                            </StyledWrapper>
                        )}
                        {!isLoading && (
                            <>
                                {errorMessage ? (
                                    <div>{errorMessage}</div>
                                ) : (
                                    <DataTable
                                        {...styles.availabilityByWarehouseTable}
                                        data-test-selector="availabilityByWarehouseModal"
                                    >
                                        <DataTableHead {...styles.availabilityByWarehouseTableHead}>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("Warehouse")}
                                            </DataTableHeader>
                                            <DataTableHeader {...styles.availabilityByWarehouseTableHeader}>
                                                {translate("QTY")}
                                            </DataTableHeader>
                                        </DataTableHead>
                                        <DataTableBody {...styles.availabilityByWarehouseTableBody}>
                                            {warehouses?.map(warehouse => (
                                                <DataTableRow
                                                    {...styles.availabilityByWarehouseTableRow}
                                                    key={warehouse.name}
                                                >
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Description"
                                                    >
                                                        {warehouse.description || warehouse.name}
                                                    </DataTableCell>
                                                    <DataTableCell
                                                        {...styles.availabilityByWarehouseTableCell}
                                                        data-test-selector="warehouseAvailabilityModal_Quantity"
                                                    >
                                                        {warehouse.qty}
                                                    </DataTableCell>
                                                </DataTableRow>
                                            ))}
                                        </DataTableBody>
                                    </DataTable>
                                )}
                            </>
                        )}
                    </Modal>
                </GridItem>
            )}
            {isRequiredDrawingApproval && (
                <GridItem {...styles.requireDrawingApprovalWrapper}>
                    <Icon src={CustomInfoIcon} {...styles.drawwingApprovalIcon}></Icon>
                    <Typography {...styles.requireDrawingApproval}>
                        {siteMessage("requiredDrwaingApprovalPdp")}
                    </Typography>
                </GridItem>
            )}
            {cart?.cartLines?.map((getProp: any, index: number) => {
                if (
                    getProp.properties.requiredDrawingApproval === "true" &&
                    isCartPage &&
                    getProp.productId === productContextModel.product.id
                ) {
                    return (
                        <GridItem {...styles.requireDrawingApprovalCartWrapper} key={index}>
                            <Icon src={CustomInfoIcon} {...styles.drawwingApprovalIcon}></Icon>
                            <Typography {...styles.requireDrawingApproval}>
                                {siteMessage("requiredDrawingApprovalCart")}
                            </Typography>
                        </GridItem>
                    );
                }
                return null;
            })}
        </SectionWrapper>
    );
};

interface PriceProps {
    currencySymbol: string;
    pricing: ProductPriceDto | null | undefined;
    qtyOrdered: number | null;
    unitOfMeasure?: string;
    showUnitOfMeasure?: boolean;
    enableVat: boolean;
    displayWithVat: boolean;
    styles: PriceStyles;
    salePriceLabel?: string;
}

const Price = ({
    currencySymbol,
    pricing,
    qtyOrdered,
    unitOfMeasure,
    showUnitOfMeasure = true,
    enableVat,
    displayWithVat,
    styles,
    salePriceLabel,
}: PriceProps) => {
    let salePriceLabelPrefix = "";
    let greaterThanTwoPercent;
    if (pricing && salePriceLabel) {
        const { price: unitNetPrice } = getUnitNetPrice(pricing, qtyOrdered || 1);
        const { price: unitListPrice } = getUnitListPrice(pricing, qtyOrdered || 1);

        const savingsAmount = Math.round((unitListPrice - unitNetPrice) * 100) / 100;
        const savingsPercent = Math.round((savingsAmount / unitListPrice) * 100);
        greaterThanTwoPercent = savingsPercent > 2;

        if (unitNetPrice < unitListPrice) {
            salePriceLabelPrefix = `${salePriceLabel} `;
        }
    }

    return (
        <>
            {pricing ? (
                <StyledWrapper {...styles.parentLabel}>
                    <Typography data-test-selector="productPrice_unitNetPrice" {...styles.unitListPriceText}>
                        {enableVat && displayWithVat
                            ? getUnitRegularPriceWithVat(pricing, qtyOrdered || 1).priceDisplay
                            : getUnitNetPrice(pricing, qtyOrdered || 1).priceDisplay}
                    </Typography>
                    <UnitOfMeasure
                        unitOfMeasure={unitOfMeasure}
                        showUnitOfMeasure={showUnitOfMeasure}
                        styles={styles.unitOfMeasure}
                    />
                </StyledWrapper>
            ) : (
                <Typography {...styles.realTimeText} data-test-selector="productPrice_unitNetPrice_CurrencySymbol">
                    {currencySymbol}
                </Typography>
            )}

            {pricing && enableVat && (
                <Typography as="p" {...styles.vatLabelText}>
                    {displayWithVat ? `${translate("Inc. VAT")} (${pricing.vatRate}%)` : translate("Ex. VAT")}
                </Typography>
            )}
        </>
    );
};

interface UnitOfMeasureProps {
    unitOfMeasure?: string;
    showUnitOfMeasure?: boolean;
    styles?: UnitOfMeasureStyles;
}

const UnitOfMeasure = ({ unitOfMeasure, showUnitOfMeasure = true, styles }: UnitOfMeasureProps) => {
    return unitOfMeasure && showUnitOfMeasure ? (
        <Typography {...styles?.unitOfMeasureText} data-test-selector="productPrice_unitOfMeasureLabel">
            &nbsp;/&nbsp;{unitOfMeasure}
        </Typography>
    ) : null;
};

export default connect(mapStateToProps)(NISProductPriceCustomPDP);
